module.exports = '2.1.1';



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphlib/lib/version.js
// module id = 211
// module chunks = 0